
import React from 'react';
import { Link } from 'react-router-dom';
import FareHarborCalendar from '@/components/FareHarborCalendar';

interface TourBookingSectionProps {
  fareHarborItemId: number;
}

const TourBookingSection: React.FC<TourBookingSectionProps> = ({ fareHarborItemId }) => {
  return (
    <section id="book-now" className="py-12 bg-white scroll-mt-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-playfair font-bold text-2xl md:text-3xl mb-4 text-[#3E2723] text-center">
            Book Your Financial District Historical Cat Tour
          </h2>
          <p className="text-center max-w-2xl mx-auto mb-8 text-[#3E2723]/80 font-montserrat">
            Select your preferred date and time below. Tours typically run on weekends and select weekdays.
          </p>
          
          <p className="text-center mb-8 font-montserrat text-[#D32F2F] font-medium">
            Step back in time with our Financial District cat history tour—where the neighborhood's feline past comes alive through captivating stories! Feel free to bring your cat companion to experience it with you!
          </p>
          
          <FareHarborCalendar itemId={fareHarborItemId} className="mb-6" />
          
          <p className="text-center text-sm text-[#3E2723]/60 font-montserrat">
            Need help booking? <Link to="/contact" className="text-[#D32F2F] hover:underline">Contact us</Link>
          </p>
        </div>
      </div>
    </section>
  );
};

export default TourBookingSection;
